import React from 'react';
import { useLocale } from 'locale';
import { Text, SmallText } from 'ds/components/typography';
import { ShowAt } from 'consts/breakpoints';
import { LimitedText, SectionTitle, SectionType } from 'components/widget/common/styled';
import ExpandArrow from 'assets/svg/chevron-down.svg';
import { SectionIcon } from './SectionIcon';
import { TransportationSectionType } from 'store/state/insightsContext';
import { InsightType } from 'utils/entities';
import { TransportationAccordionSection } from 'store/state/selectors/insights/transportation';


const highlightRegExp = new RegExp('/<span*.+<\/span>/', 'g');

interface TitleProps {
  section: TransportationAccordionSection;
  activeSection: TransportationSectionType;
  toggleActiveSection: () => void;
}

export const Title: React.FunctionComponent<TitleProps> = ({ section, activeSection, toggleActiveSection }) => {
  const { t } = useLocale();

  const countRoutes = (): number => {
    if ('routes' in section) {
      return section.routes ? section.routes.length : 0;
    }
    else if (section.tabs && section.tabs.length) {
      return section.tabs.reduce((res, tab) => res += (tab.routes ? tab.routes.length : 0), 0);
    }
    else {
      return 0;
    }
  };

  return (
    <SectionTitle
      onClick={toggleActiveSection}
      type={InsightType.Transportation}
      isActive={activeSection === section.sectionId}
    >
      <SectionType type={InsightType.Transportation}>
        <SectionIcon sectionId={section.sectionId} />
        <SmallText weight="medium" style={{ textTransform: 'uppercase' }}>
          {t('transportationAccordion.sectionType', {
            type: section.sectionId,
            routesAmount: countRoutes(),
          })}
        </SmallText>
      </SectionType>
      <LimitedText maxWidth={385}>
        <ShowAt from={2}>
          <Text style={{ margin: '0 32px' }}>
            <span dangerouslySetInnerHTML={{ __html: section.sectionResume }} />
          </Text>
        </ShowAt>
        <ShowAt to={1}>
          {activeSection !== section.sectionId ? (
            <Text style={{ margin: '0 16px' }}>
              <span
                dangerouslySetInnerHTML={{ __html: section.sectionResume.match(highlightRegExp)
                  ? section.sectionResume.match(highlightRegExp)[0]
                  : '',
                }}
              />
            </Text>
          ) : null}
        </ShowAt>
      </LimitedText>
      <ExpandArrow width={22} height={22} />
    </SectionTitle>
  );
};
